import React from 'react';
import Error from '../error';

function NoAnswer({ t, onCancelClicked }) {
  return <Error error={ { errors: [t('chat.no_answer')] } } onCancelClicked={ onCancelClicked } />;
}

export default NoAnswer;
